import { Flex } from 'foundations-components/components/Flex';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
function Loading() {
  return /*#__PURE__*/_jsx(Flex, {
    alignItems: "center",
    justifyContent: "center",
    minBlockSize: "50vh",
    children: /*#__PURE__*/_jsx(LoadingSpinner, {})
  });
}
export default Loading;